<template>
  <div class="wrapper">
    <Header class="header" @rental="rental" :type="'order'"></Header>
    <div class="container">
      <!-- content(s) -->
      <div id="content" class="fullH transparent landing rental">
        <section class="landingVisual beginer bg02">
          <div class="inner">
            <!-- <p class="desc">쉽고 빠른 웰몰의 렌탈</p> -->
            <p class="copy">
              <strong class="txtLine">
                웰몰에서
                <br />
                구매하기
              </strong>
            </p>
          </div>
          <div class="btnArea sticky">
            <button type="button" class="btn_p" @click="goPaymentStep1()">
              시작하기
            </button>
          </div>
        </section>

        <ConfirmPop @cancel="cancel" @confirm="confirm" @close="close" v-if="confirmPop">
          <p v-html="msg"></p>
        </ConfirmPop>
      </div>
      <!-- content(e) -->
    </div>
    <!-- container(e) -->
    <footer class="footer"></footer>
  </div>
</template>

<script>
import ApiService from '@/common/api.service';
import ConfirmPop from '@/components/popup/ConfirmPop';
import { RENTAL_ADD_CART } from '@/store/message.type.js';

export default {
  name: 'paymentMemberMain',
  components: {
    ConfirmPop,
  },
  data() {
    return {
      productCode: '',
      orderId: '',
      color: '',
      coupon: '',
      couponSerialNumber: '',
      confirmPop: false,
      msg: '',
      internalProdCode: '',
      marParam: '',
      goodsTpCd: '',
    };
  },
  created() {
    //비회원 -> 회원가입으로 온경우
    const paymentInfo = this.$route.params.paymentInfo;
    if (paymentInfo != null) {
      this.productCode = paymentInfo.productCode;
      this.color = paymentInfo.color;
      this.coupon = paymentInfo.coupon;
      this.couponSerialNumber = paymentInfo.couponSerialNumber;
      this.orderId = paymentInfo.orderId;
      this.order2_productOption1 = paymentInfo.order2_productOption1;
      this.order2_productOption2 = paymentInfo.order2_productOption2;
      this.order2_productOption3 = paymentInfo.order2_productOption3;
      this.saleAmount = paymentInfo.saleAmount;
      this.internalProdCode = paymentInfo.internalProdCode;
    } else {
      this.productCode = this.$route.params.productCode;
      this.color = this.$route.params.productColors;
      this.coupon = this.$route.params.coupon;
      this.couponSerialNumber = this.$route.params.couponSerialNumber;
      this.orderId = this.$route.params.orderId;
      this.marParam = this.$route.params.marParam;
      this.goodsTpCd = this.$route.params.goodsTpCd;
      this.order2_productOption1 = this.$route.params.order2_productOption1;
      this.order2_productOption2 = this.$route.params.order2_productOption2;
      this.order2_productOption3 = this.$route.params.order2_productOption3;
      this.saleAmount = this.$route.params.saleAmount;
      this.internalProdCode = this.$route.params.internalProdCode;
    }
  },
  mounted() {
    if (!this.orderId) {
      if (this.goodsTpCd === 'RPRO00SU') {
        console.log('1');
        this.getGoodsOrderId();
      } else {
        console.log('2');
        this.getOrderId();
      }
    }
  },
  methods: {
    getGoodsOrderId() {
      console.log('this.goodsTpCd::::', this.goodsTpCd);
      ApiService.service('GET', '/order/goodsId')
        .then(({ data }) => {
          console.log('data.result::::', data.result);
          this.orderId = data.result;
        })
        .catch(({ response }) => {
          console.log('::::::', response);
        });
    },
    getOrderId() {
      ApiService.service('GET', '/order/id')
        .then(({ data }) => {
          console.log('data.result2::::', data.result);
          this.orderId = data.result;
        })
        .catch(({ response }) => {
          console.log(response);
        });
    },
    goPaymentStep1() {
      this.$router.push({
        name: 'paymentStep1',
        params: {
          productCode: this.productCode,
          orderId: this.orderId,
          color: this.color,
          coupon: this.coupon,
          couponSerialNumber: this.couponSerialNumber,
          order2_productOption1: this.order2_productOption1,
          order2_productOption2: this.order2_productOption2,
          order2_productOption3: this.order2_productOption3,
          saleAmount: this.saleAmount,
          internalProdCode: this.internalProdCode,
        },
      });
    },
    rental() {
      //장바구니에 담을건지 ConfirmPop 노출
      // this.popMsg = RENTAL_ADD_CART; // 렌탈시작은 GO_HOME 사용 ( MemberMain 등 )
      // customjs.lp.open('#confirmPop');
      this.msg = RENTAL_ADD_CART; // 렌탈시작은 GO_HOME 사용 ( MemberMain 등 )
      this.confirmPop = true;
    },
    cancel() {
      // 취소 선택시 페이지이동
      this.$router.replace('/');
    },
    confirm() {
      // 확인 선택시 기간계용 상품 조회 이후 장바구니 api 호출
      this.getProdInfo();
    },
    close() {
      this.confirmPop = false;
    },
    getProdInfo() {
      //상품 정보 조회
      ApiService.service('GET', `/product/${this.productCode}`)
        .then(({ data }) => {
          if (data && data.result) {
            this.internalProdCode = data.result.productDetail.internalProdCode; //저장용 상품코드(ex : FH4b4990562PO)
            this.goBasket();
          }
        })
        .catch(({ response }) => {
          console.log(response);
        });
    },
    goBasket() {
      //장바구니
      let param = new Object();
      let request = new Object();
      request.internalProdCode = this.internalProdCode;
      request.colorCode = this.color;
      request.basketCd = 'BSKT0002'; //구매

      param.request = request;
      param.serviceType = 'app';

      ApiService.service('POST', '/user/auth/basket', param)
        .then(({ data }) => {
          if (data.isSucceed) {
            this.$router.replace('/');
          }
        })
        .catch(({ response }) => {
          alert('errror');
          console.log(response);
        });
    },
  },
};
</script>
